module.exports = __webpack_public_path__ + "static/media/swinburne.699c62d1.png";